import React from 'react'
import ErrorLogo from 'assets/images/error_logo.png'
import { Trans } from 'react-i18next';

class FullLayoutError extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
        return (
          (<div className="error-message-container">
            <img src={ErrorLogo} />
            <h1>
              <Trans i18nKey={"error.we_lost_this_page"} />
            </h1>
            <h3>
              <Trans i18nKey={"error.the_page_you_are_looking"} />
            </h3>
          </div>)
        );
    }

    return this.props.children ?? null;
  }
}

export default FullLayoutError;
